import React from "react";

import { view } from "modules/Payments";

const ReportsPage = () => <view.Reports />;

export default ReportsPage;
